/**
 * Privacy Policy Page
 * © 2026 A-1 Affiliate Marketing LLC - All Rights Reserved
 */

import React from 'react';
import MachineTranslationNotice from './MachineTranslationNotice';
import './LegalPage.css';

const PrivacyPolicy = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <button onClick={() => window.history.back()} className="back-btn">← Back</button>

        <MachineTranslationNotice />
        
        <h1>PRIVACY POLICY</h1>
        <p className="subtitle">SuperBrain Agentic Aggregate</p>
        <p className="effective-date">Effective Date: April 1, 2026</p>
        <p className="copyright">© 2026 A-1 Affiliate Marketing LLC. All Rights Reserved.</p>

        <section>
          <h2>1. Information We Collect</h2>
          <h3>1.1 Personal Information</h3>
          <ul>
            <li>Email address</li>
            <li>Payment information (processed by Stripe)</li>
            <li>Account credentials (encrypted)</li>
          </ul>
          
          <h3>1.2 Usage Information</h3>
          <ul>
            <li>Chat queries and responses</li>
            <li>Service usage statistics</li>
            <li>Session information</li>
            <li>IP address and browser data</li>
          </ul>
          <p><strong>Do not enter confidential information, medical or financial information, or information protected by legal privilege that you do not want processed by third-party AI providers.</strong></p>
        </section>

        <section>
          <h2>2. How We Use Your Information</h2>
          <p>We use collected information to:</p>
          <ul>
            <li>Provide and maintain the Service</li>
            <li>Process payments and subscriptions</li>
            <li>Monitor and analyze usage</li>
            <li>Improve our Service</li>
            <li>Communicate with you</li>
            <li>Comply with legal obligations</li>
          </ul>
        </section>

        <section>
          <h2>3. Data Sharing</h2>
          <p>We do NOT sell your personal information. We share data only with:</p>
          <p>A-1 Affiliate Marketing LLC operates other websites, and customer data is not shared between those sites without your consent.</p>
          <ul>
            <li><strong>Stripe</strong>: For payment processing</li>
            <li><strong>AI processing through OpenRouter</strong>: Prompts you submit are routed through OpenRouter to the AI model providers selected to generate a response. Those providers process prompts under their own terms and privacy policies.</li>
            <li><strong>Legal Authorities</strong>: When required by law</li>
          </ul>
        </section>

        <section>
          <h2>4. Data Security</h2>
          <p>We implement industry-standard security measures:</p>
          <ul>
            <li>JWT authentication</li>
            <li>Encrypted database storage</li>
            <li>Secure HTTPS connections</li>
            <li>Password hashing with bcrypt</li>
          </ul>
        </section>

        <section>
          <h2>5. Data Retention</h2>
          <ul>
            <li><strong>Account information</strong>: Retained while your account is active</li>
            <li><strong>Chat history</strong>: Retained for service improvement</li>
            <li><strong>Usage data</strong>: Retained for billing and analytics</li>
            <li><strong>Deleted accounts</strong>: Data removed within 30 days</li>
          </ul>
        </section>

        <section>
          <h2>6. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access your personal data</li>
            <li>Request data deletion</li>
            <li>Opt-out of marketing communications</li>
            <li>Export your data</li>
          </ul>
        </section>

        <section>
          <h2>7. Cookies</h2>
          <p>We use cookies for:</p>
          <ul>
            <li>Session management</li>
            <li>Analytics</li>
            <li>Security</li>
          </ul>
        </section>

        <section>
          <h2>8. Third-Party Services</h2>
          <p>Our Service uses:</p>
          <ul>
            <li><strong>Stripe</strong>: Payment processing</li>
            <li><strong>OpenRouter and AI model providers</strong>: Prompt routing and response generation</li>
            <li><strong>Cloudflare</strong>: CDN and security</li>
          </ul>
          <p>Each has its own privacy policy.</p>
        </section>

        <section>
          <h2>9. Children's Privacy</h2>
          <p>The Service is not intended for users under 13. We do not knowingly collect data from children.</p>
        </section>

        <section>
          <h2>10. International Users</h2>
          <p>Your information may be transferred to and processed in the United States.</p>
        </section>

        <section>
          <h2>11. Changes to Privacy Policy</h2>
          <p>We may update this Privacy Policy. Continued use after changes constitutes acceptance.</p>
        </section>

        <section>
          <h2>12. Contact Us</h2>
          <p>For privacy concerns, contact:</p>
          <p><strong>A-1 Affiliate Marketing LLC</strong></p>
          <p>Email: <a href="mailto:a1affiliatemarketingllc@gmail.com">a1affiliatemarketingllc@gmail.com</a></p>
          <p>Website: https://superbrain.life</p>
        </section>

        <div className="footer-blessing">
          <p><strong>Your privacy is protected by our Catholic values and Marine Corps integrity.</strong></p>
          <p>✝ GOD BLESS EVERYONE ✝</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
